/* El ingreso con QR y con llave de acceso, contra la función `acceso` de
 * Supabase (ver supabase/functions/acceso). La función valida y devuelve un
 * `token_hash`; acá se canjea por una sesión común de Supabase Auth. */
import {
  startAuthentication,
  startRegistration,
} from "@simplewebauthn/browser";

import { supabase } from "../supabase/SupabaseClient";
import { marcarLlave } from "../shared/acceso";

async function pedir(accion, datos = {}) {
  const { data, error } = await supabase.functions.invoke("acceso", {
    body: { accion, ...datos },
  });
  if (error) {
    // 401/429 llegan como error con el cuerpo adentro.
    let cuerpo = null;
    try {
      cuerpo = await error.context?.json?.();
    } catch {
      /* sin cuerpo */
    }
    const e = new Error(cuerpo?.error || error.message || "acceso");
    e.codigo = cuerpo?.error;
    throw e;
  }
  return data;
}

// El canje: el mismo camino para el QR y la llave.
export async function canjear(tokenHash) {
  const { error } = await supabase.auth.verifyOtp({
    token_hash: tokenHash,
    type: "magiclink",
  });
  if (error) throw error;
  sessionStorage.setItem("isLogged", "true");
}

// ── QR ──────────────────────────────────────────────────────────────────
export const qrNuevo = () => pedir("qr_nuevo");
export const qrEstado = (token, nonce) => pedir("qr_estado", { token, nonce });
export const qrVer = (token) => pedir("qr_ver", { token });
export const qrResponder = (token, aprobar) =>
  pedir("qr_responder", { token, respuesta: aprobar ? "aprobar" : "rechazar" });

export const linkDelQr = (token) => `${window.location.origin}/qr/${token}`;

// ── Llaves ──────────────────────────────────────────────────────────────
export async function crearLlave() {
  const { opciones, reto_id } = await pedir("llave_opciones_registro");
  const credencial = await startRegistration({ optionsJSON: opciones });
  const r = await pedir("llave_registrar", { reto_id, credencial });
  if (!r?.ok) throw new Error(r?.error || "registro");
  marcarLlave();
  return r;
}

export async function entrarConLlave() {
  const { opciones, reto_id } = await pedir("llave_opciones_entrada");
  const credencial = await startAuthentication({ optionsJSON: opciones });
  const r = await pedir("llave_entrar", { reto_id, credencial });
  if (!r?.ok || !r.token_hash) {
    const e = new Error(r?.error || "entrada");
    e.codigo = r?.error;
    throw e;
  }
  await canjear(r.token_hash);
  marcarLlave();
}

export const listarLlaves = async () => (await pedir("llave_listar"))?.llaves || [];
export const borrarLlave = (id) => pedir("llave_borrar", { id });

// La persona cerró la ventana del navegador o dijo que no: no es un error
// para mostrar.
export const fueCancelada = (e) =>
  ["NotAllowedError", "AbortError"].includes(e?.name) ||
  ["NotAllowedError", "AbortError"].includes(e?.cause?.name);
